import { Link } from 'react-router-dom';

interface LegalLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export default function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-white">
      <nav className="border-b border-border">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/Eextramile1.png" alt="" className="h-8 w-auto object-contain" />
            <span className="font-bold text-ink text-sm tracking-tight">Eextramile <span className="text-g">AI</span></span>
          </Link>
          <Link to="/" className="text-sm text-muted hover:text-ink transition-colors">
            ← Back
          </Link>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-[28px] font-semibold leading-snug text-ink mb-1" style={{ fontFamily: 'Instrument Serif, serif' }}>
          {title}
        </h1>
        <p className="text-sm text-hint mb-10">Last updated: {lastUpdated}</p>

        <div className="prose-legal text-sm text-ink2 leading-relaxed space-y-6">
          {children}
        </div>
      </main>

      <style>{`
        .prose-legal h2 {
          font-family: 'Lora', serif;
          font-size: 17px;
          font-weight: 600;
          color: var(--ink);
          margin-top: 2rem;
          margin-bottom: 0.5rem;
        }
        .prose-legal h2:first-child { margin-top: 0; }
        .prose-legal p { margin-bottom: 0.75rem; }
        .prose-legal ul { list-style: disc; padding-left: 1.25rem; margin-bottom: 0.75rem; }
        .prose-legal li { margin-bottom: 0.35rem; }
        .prose-legal a { color: var(--g); text-decoration: underline; }
        .prose-legal strong { color: var(--ink); font-weight: 600; }
        .prose-legal .placeholder {
          background: #fff3cd;
          color: #7a5c00;
          padding: 0.1rem 0.35rem;
          border-radius: 4px;
          font-size: 0.85em;
        }
      `}</style>
    </div>
  );
}
